import React from 'react';
import { Divider, Typography } from '@material-ui/core';
import { ParsedCartData, ParsedPlanData } from 'src/components/PlanQueue/PlanQueue.types';
import styles from 'src/components/PlanQueue/PlanQueue.styles';

interface PlanPopoverContentProps {
  assortmentItems: ParsedPlanData;
  allocationItems: ParsedPlanData;
  cartItems: ParsedCartData;
  showAllocation: boolean;
  assortmentPlanError?: boolean;
  allocationPlanError?: boolean;
  addToAsstError?: boolean;
}

export const PlanPopoverContent = ({
  assortmentItems,
  allocationItems,
  cartItems,
  showAllocation,
  assortmentPlanError,
  allocationPlanError,
  addToAsstError,
}: PlanPopoverContentProps) => {
  return (
    <div style={{ minWidth: 325 }}>
      <Typography>Status</Typography>
      <div>
        <div style={{ display: 'flex', justifyContent: 'space-evenly', margin: '0.5rem 0' }}>
          <section style={{ minWidth: 135, minHeight: 135 }}>
            <Typography variant="overline">Assortment</Typography>
            {assortmentPlanError ? (
              <div className={styles.popoverErrorMessage}>⚠️ Cannot Fetch Assortment Plan Queue</div>
            ) : (
              <ul>
                <li>
                  <div className="list-popover-container">
                    <div>Pending: {assortmentItems.pending.length}</div>
                  </div>
                </li>
                <li>
                  <div className="list-popover-container">
                    <div>Processing: {assortmentItems.processing.length}</div>
                  </div>
                </li>
                <li>
                  <div className="list-popover-container">
                    <div>Completed: {assortmentItems.completed.length}</div>
                  </div>
                </li>
                <li>
                  <div className="list-popover-container">
                    <div>Failed: {assortmentItems.failed.length}</div>
                  </div>
                </li>
              </ul>
            )}
          </section>
          <Divider orientation="vertical" flexItem={true} />
          <section style={{ minWidth: 135, minHeight: 135 }}>
            <Typography variant="overline">Cart</Typography>
            {addToAsstError ? (
              <div className={styles.popoverErrorMessage}>⚠️ Cannot Fetch Add to Assortment Status</div>
            ) : (
              <ul>
                <li>
                  <div className="list-popover-container">
                    <div>Processing: {cartItems.processing.length}</div>
                  </div>
                </li>
                <li>
                  <div className="list-popover-container">
                    <div>Failed: {cartItems.failed.length}</div>
                  </div>
                </li>
              </ul>
            )}
          </section>
        </div>

        {showAllocation ? (
          <React.Fragment>
            <Divider variant="middle" />
            <div style={{ display: 'flex', justifyContent: 'space-evenly', margin: '0.5rem 0' }}>
              <section style={{ minWidth: 135, minHeight: 135 }}>
                <Typography variant="overline">Allocation</Typography>
                {allocationPlanError ? (
                  <div className={styles.popoverErrorMessage}>⚠️ Cannot Fetch Allocation Plan Queue</div>
                ) : (
                  <ul>
                    <li>
                      <div className="list-popover-container">
                        <div>Processing: {allocationItems.processing.length}</div>
                      </div>
                    </li>
                    <li>
                      <div className="list-popover-container">
                        <div>Completed: {allocationItems.completed.length}</div>
                      </div>
                    </li>
                    <li>
                      <div className="list-popover-container">
                        <div>Failed: {allocationItems.failed.length}</div>
                      </div>
                    </li>
                  </ul>
                )}
              </section>
              <Divider orientation="vertical" flexItem={true} />
              <section style={{ minWidth: 135, minHeight: 135 }}></section>
            </div>
          </React.Fragment>
        ) : null}
      </div>
    </div>
  );
};
